/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBookingSingle201, PostApiBookingSingleMutationRequest, PostApiBookingSingleMutationResponse, PostApiBookingSingleQueryParams } from "../entities/PostApiBookingSingle";
import { modelsBookingCreateInputSchema } from "./models/bookingCreateInputSchema";
import { modelsBookingGroupOutputSchema } from "./models/bookingGroupOutputSchema";
import { z } from "zod/v4";

export const postApiBookingSingleQueryParamsSchema = z.object({
    "branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<PostApiBookingSingleQueryParams>

/**
 * @description Created
 */
export const postApiBookingSingle201Schema = z.lazy(() => modelsBookingGroupOutputSchema) as unknown as z.ZodType<PostApiBookingSingle201>

/**
 * @description Данные записи
 */
export const postApiBookingSingleMutationRequestSchema = z.lazy(() => modelsBookingCreateInputSchema) as unknown as z.ZodType<PostApiBookingSingleMutationRequest>

export const postApiBookingSingleMutationResponseSchema = z.lazy(() => postApiBookingSingle201Schema) as unknown as z.ZodType<PostApiBookingSingleMutationResponse>